async function getStoreReviews() {
    console.log('Pramod Check getStoreReviews');
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            showPosition_store,
            showError,
            { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
        );
    } else {
        console.log("Geolocation is not supported by this browser.");
    }
}

// Function to call store API
async function callStoreAPI() {
    const locationData = localStorage.getItem('location_store');
    const obj = JSON.parse(locationData);

    let url;
    if (obj.postal) {
        if (obj.lat && obj.lng) {
            url = `${storeApiUrl}/near-by?latitude=${obj.lat}&longitude=${obj.lng}`;
        } else {
            url = `${storeApiUrl}/near-by?latitude=${obj.latitude}&longitude=${obj.longitude}`;
        }
    } else {
        url = `${storeApiUrl}/near-by?city=${obj.state}`;
    }

    try {
        let data;
        if (obj) {
            data = obj;
        } else {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            data = await response.json();
        }

        const waitForElements = () => {
            const appmtImage = document.querySelector('.appmt-image');
            const bookAppmtBtn = document.querySelectorAll('.store-more-footer');

            if (appmtImage || bookAppmtBtn.length > 0) {
                if (data?.address?.toLowerCase()?.includes('bengaluru') || data?.full_addr?.toLowerCase()?.includes('bengaluru')) {
                    appmtImage?.classList.remove('no-store-display');
                    bookAppmtBtn.forEach((el) => el?.classList.remove('no-store-display'));
                } else {
                    appmtImage?.classList.add('no-store-display');
                    bookAppmtBtn.forEach((el) => el?.classList.add('no-store-display'));
                }

                observer.disconnect();
            }
        };

        // Set up a MutationObserver to watch for DOM changes
        const observer = new MutationObserver(() => {
            waitForElements();
        });

        // Start observing the body for child node changes
        observer.observe(document.body, { childList: true, subtree: true });
        return data;
    } catch (error) {
        throw new Error('Error fetching store data: ' + error.message);
    }
}

// Function to handle errors
function showError(error) {
    switch (error.code) {
        case error.PERMISSION_DENIED:
            console.error("User denied the request for Geolocation.");
            break;
        case error.POSITION_UNAVAILABLE:
            console.error("Location information is unavailable.");
            break;
        case error.TIMEOUT:
            console.error("The request to get user location timed out.");
            break;
        case error.UNKNOWN_ERROR:
            console.error("An unknown error occurred.");
            break;
    }
}

// Function to show position
function showPosition_store(position) {
    console.log('pramod check showPosition_store');
    const { latitude, longitude } = position.coords;
    // Pass the location to your function to handle data
    handleStoreData(latitude, longitude);
}

// Function to handle store data
async function handleStoreData(latitude, longitude) {
    console.log('Pramod check handleStoreData', latitude, longitude);
    try {
        const data = await callStoreAPI(latitude, longitude);
        if (data.storeList && data.storeList.length > 0) {
            updateStoreHTML(data.storeList, data);
        } else {
            // Handle the case when no store is found
            const moreStoreElement = document.querySelectorAll(".ct_more_store");
            const appmtImage = document.querySelector('.appmt-image');

            moreStoreElement?.forEach((ele) => {
                ele.style.display = "none";
            });

            if (appmtImage) {
                appmtImage.style.display = 'none';
            }
        }
    } catch (error) {
        console.error("Error fetching store data:", error);
    }
}

// Function to update HTML with store data
function updateStoreHTML(storeList, data) {
    let storeHTMLSliced = '';
    let storeHTMLAll = '';

    const locationData = JSON.parse(localStorage.getItem('location_store'));
    const storeCity = locationData.state
        ? `<a href="https://www.kushals.com/pages/store/${data.slug}">View All</a>`
        : `<a href="https://www.kushals.com/pages/stores/">View All</a>`;

    // Generate HTML for sliced stores (up to 4)
    const storesToShow = storeList.slice(0, 4);
    storesToShow.forEach(store => {
        storeHTMLSliced += generateStoreHTML(store, data);
    });

    // Generate HTML for all stores
    storeList.forEach(store => {
        storeHTMLAll += generateStoreHTML(store, data);
    });

    const moreStoreElements = document.querySelectorAll(".ct_more_store");
    const appmtImage = document.querySelector('.appmt-image');

    if (moreStoreElements) {
        moreStoreElements.forEach((ele) => {
            if (ele.classList.contains('show-all-stores')) {
                ele.innerHTML = wrapStoreHTML(storeHTMLAll, "All Stores Near You", storeCity);
            } else {
                ele.innerHTML = wrapStoreHTML(storeHTMLSliced, "Stores Near You To Assist", storeCity);
            }
            ele.style.display = "block"; // Show the element
        });
    }

    if (appmtImage) {
        appmtImage.style.display = 'block';
    }
}

// Helper to generate individual store HTML
function generateStoreHTML(store, data) {
    const openingTime = convertTo12HourFormat(store.openingTime);
    const closingTime = convertTo12HourFormat(store.closingTime);
    const openTime = openingTime.split(" ")[0];
    const timeCheck = updateStoreTime(openTime, store.closingTime, closingTime);

    const city = store.city || 'Unknown City';
    return `
        <div class="store-more-box store-more-box-product appmt-store-box" data-store-id="${store.id}">
            <div class="store-more-box-inner">
                <a class="store_pro-link ct_store_click" data-store="${store.name}" href="https://www.kushals.com/pages/store-details/${city}-${store.slug}">
                    <div class="store-more-box-head">
                        <div class="store-more-name">
                            <span>${store.name}</span>
                        </div>
                        <div class="store-more-star">
                            <img src="https://cdn.shopify.com/s/files/1/0796/1959/files/google.png?v=1721205440" width="30" height="30">
                            <span>${store.rating}</span>
                        </div>
                    </div>
                    <div class="store-more-text">
                        ${store.address}
                    </div>
                </a>
                <div class="call-dir-main">
                    <a href="tel:+91${store.phone}" class="ct_store_call" data-store="${store.name}">
                        <div class="call-main">
                            <div class="call-icon">
                                <img src="https://cdn.shopify.com/s/files/1/0796/1959/files/fluent_call-28-regular_8421deb0-ea92-4d83-b8eb-83dd7c87b04b.png?v=1720074796" alt="">
                            </div>
                            <span>Call Store</span>
                        </div>
                    </a>
                    <div class="direction-main">
                        <div class="direction-icon">
                            <img src="https://cdn.shopify.com/s/files/1/0796/1959/files/teenyicons_direction-solid.png?v=1719300137" alt="">
                        </div>
                        <span><a class="ct_store_map" data-store="${store.name}" href="${store.direction}" target="_blank">Get Direction</a></span>
                    </div>
                    ${timeCheck}
                </div>
            </div>
            <div class="store-more-footer">
                <button type="button" class="book-appmt-button" onclick="handleAppointmentAction(this)">Book Appointment</button>
            </div>
        </div>`;
}

// Helper to wrap the stores with a header and storeCity
function wrapStoreHTML(storeHTML, heading, storeCity) {
    return `
        <div class="store-more-head">
            <span>${heading}</span>
            <div class="store-more-all ct_all_store">${storeCity}</div>
        </div>
        <div class="store-more-content near-stores">${storeHTML}</div>`;
}

// Function to convert time to 12-hour format
function convertTo12HourFormat(time) {
    let [hours, minutes] = time.split(':').map(Number);
    const period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert hour to 12-hour format
    return `${hours}:${minutes.toString().padStart(2, '0')} ${period}`;
}

// Function to check store open/close time
function updateStoreTime(openTime, closeTime, storeCloseTime) {
    const currentTime = new Date();
    const openingDate = new Date(currentTime);
    const closingDate = new Date(currentTime);

    const [openHours, openMinutes] = openTime.split(':').map(Number);
    const [closeHours, closeMinutes] = closeTime.split(':').map(Number);

    openingDate.setHours(openHours, openMinutes, 0);
    closingDate.setHours(closeHours, closeMinutes, 0);

    if (closingDate <= openingDate) {
        closingDate.setDate(closingDate.getDate() + 1);
    }

    if (currentTime >= openingDate && currentTime < closingDate) {
        return `<div class="open-close-store"> <div class="dot"></div> <span>Open</span> </div>`;
    } else {
        return `<div class="open-close-store close_store"> <div class="dot"></div> <span>Closed</span> </div>`;
    }
}

jQuery(document).ready(function () {
    if(window.page === 'product') {
        $(window).on("scroll.moreStore", function () {
            var scrollTop = $(window).scrollTop(); // Current scroll position
            var windowHeight = $(window).height(); // Viewport height
            var section = $(".ct_more_store "); // Target section
    
            if (section.length === 0) {
                return; // Exit if the section does not exist
            }
    
            var offset = section.offset().top; // Distance from top of the document to the section
            // Check if the section is in view
            if (scrollTop + windowHeight >= offset) {
                handleStoreData("123", "321"); // Call your function
                $(window).off("scroll.moreStore"); // Remove scroll listener to prevent further calls
            }
        });
    } else {
        const interval = setInterval(() => {
            if (localStorage.getItem('location_store')) {
                handleStoreData("123", "321");
                clearInterval(interval);
            }
        }, 1000);
    }
    

    if (localStorage.getItem('pin') != undefined) {
        var pin_get = localStorage.getItem('pin');
        jQuery(".clickpost-edd__drop_pincode-input").val(pin_get);
        pin_checker(pin_get);
    }

    jQuery(document).on("input", ".clickpost-edd__form .clickpost-edd__drop_pincode-input", function () {
        const input_pin_number = jQuery(".clickpost-edd__drop_pincode-input").val();
        if (input_pin_number.length === 6) {
            pin_check(input_pin_number);
            pin_checker(input_pin_number);
        } else if (input_pin_number == "") {
            jQuery(".ct_msg_show").hide();
        }
    });
});

function pin_checker(pin_number) {
    if (pin_number.length === 6) {
        jQuery(".clickpost-edd__drop_pincode-input").val(pin_number);
        jQuery(".clickpost-edd__form .clickpost-edd__submit-button").trigger("click");
    }
}

function count_date(c_date_no) {
    const d = new Date();
    d.setDate(d.getDate() + c_date_no);

    const date = d.getDate();
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    const month = monthNames[d.getMonth()];

    const weekdayNames = [
        "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    ];
    const weekday = weekdayNames[d.getDay()];

    return { date, week: weekday, month };
}

jQuery(document).on("click",".ct_store_call",function(){
    var store_name=jQuery(this).attr("data-store");
    clevertap.event.push("Call_Store", {
        "CallStore_Name":store_name
    });
});

$(document).on("click", ".ct_store_click", function () {
    const storeName = $(this).data("store");
    clevertap.event.push("Store_Name", { "Store Name": storeName });
});

$(document).on("click", ".ct_store_map", function () {
    const storeName = $(this).data("store");
    clevertap.event.push("Store_Name_Direction", { "Store Name direction": storeName });
});

$(document).on("click", ".ct_all_store a", function () {
    clevertap.event.push("MoreStores");
});